export default __webpack_public_path__ + "static/media/shirt1.836ffb19.jpeg";